export default {
  dbi_company_company_lowercase: '公司',
  dbi_company_companies: '公司',
  dbi_company_game_type: '游戏类型',
  dbi_company_ipo_status: '上市状态',
  dbi_company_headquaters: '总部',
  dbi_company_public: '上市',
  dbi_company_private: '非上市',
  dbi_company_delisted: '退市',
  dbi_company_game_owned: '拥有的游戏',
  dbi_company_listed: '上市',
  dbi_company_and: '和',
  dbi_company_company_revenue: '公司收入',
  dbi_company_company_downloads: '公司下载',
  dbi_company_filter_tips_1_row: 'PC 和主机游戏的线下销售收入来自 NPD，',
  dbi_company_filter_tips_2_row: '仅涵盖美国数据。',
  dbi_company_filter_tips_3_row: 'PC 和主机游戏的线上收入来自 M Science，',
  dbi_company_filter_tips_4_row: '覆盖美国、英国、德国、法国和西班牙。',
  dbi_company_metrics_sum_revenue: '总收入（美元）',
  dbi_company_metrics_mobile_revenue: '手游收入（美元）',
  dbi_company_metrics_pc_revenue: '端游收入（美元）',
  dbi_company_metrics_pc_digital_revenue: '端游线上收入（美元）',
  dbi_company_metrics_pc_physical_revenue: '端游零售收入（美元）',
  dbi_company_metrics_console_revenue: '主机游戏收入（美元）',
  dbi_company_metrics_console_digital_revenue: '主机游戏线上收入（美元）',
  dbi_company_metrics_console_physical_revenue: '主机游戏零售收入（美元）',
  dbi_company_cb_info_tips: 'Crunchbase 提供公司介绍、财务活动和团队成员。',
  dbi_company_tables_info_tips1: '汇总您选择的游戏类型的收入。',
  dbi_company_tables_info_tips2:
    '这里汇总了 NPD（仅限美国数据）和 Mscience（仅限美国、英国、法国、德国和西班牙财务报告数据）的收入。',
  dbi_company_downloads_mentions_info_tips: '条目按该度量标准降序排列。请仅选择所选信息的条目。数据来源：',

  dbi_company_parent: '母公司',
  dbi_company_subsidiary: '子公司',

  dbi_company_tab_newsactivity: '新闻&活动',
  dbi_company_tab_gamesstats: '游戏&详情',
  dbi_company_tab_subsidiary_companies: '子公司',
  dbi_company_tab_similar_companies: '相似公司',

  dbi_company_media_news: '媒体新闻',
  dbi_company_new_games: '新游',
  dbi_company_activities: '活动',

  dbi_company_about: '关于',
  dbi_company_employee: '员工',
  dbi_company_founded_date: '创建日期',
  dbi_company_last_funding_type: '最后供资类型',
  dbi_company_also_known_as: '又称',
  dbi_company_website: '网站',

  dbi_company_game_performance_summary: '游戏表现摘要',
  dbi_company_game_performance_summary_tips: '这里显示的是与游戏相关的指标，该公司是游戏开发商或发行商。',
  dbi_company_recent_news_activity: '最新新闻&活动',
  dbi_company_original_news: '原始新闻',

  dbi_company_news_activity_original_text: '原文',
  dbi_company_news_activity_translate_to_en: '全部翻译成英文',
  dbi_company_news_activity_translate_to_cn: '全部翻译成中文',
  dbi_company_mobile_metrics: '手游指标',
  dbi_company_pc_metrics: 'PC游戏指标',
  dbi_company_console_metrics: '主机游戏指标',
  dbi_company_units_company: `公司收入百分比`,
  dbi_company_revenue_company: `收入占公司比例`,
  dbi_company_revenue$_company: `收入（美元） 占公司百分比`,
  dbi_company_download_company: `下载量`,

  dbi_company_go_to: '前往',

  dbi_company_ipo_stock_price: '首次公开募股和股票价格',
  dbi_company_investments: '$ 投资',
  dbi_company_investors: '$ 投资者',
  dbi_company_founding_round: '创始轮次',
  dbi_company_acquisitions: '$ 收购',
  dbi_company_exits: '$ 撤资',
  dbi_company_ticker: '的注册代码为',
  dbi_company_symbol: '股票代码',
  dbi_company_exiValuatlin: '首次公开募股时的估值',
  dbi_company_ipo_date: '上市时间',
  dbi_company_number_investments: '投资数目',
  dbi_company_number_lead_investments: '首席投资数量',
  dbi_company_announced_date: '公布日期',
  dbi_company_organization_name: '组织名称',
  dbi_company_lead_investor: '首席投资者',
  dbi_company_money: '筹集资金（美元）',
  dbi_company_number_investors: '投资者数量',
  dbi_company_number_lead_investors: '首席投资者数量',
  dbi_company_investors_name: '投资者名称',
  dbi_company_partners: '合作伙伴',
  dbi_company_number_funding_rounds: '筹资回合数',
  dbi_company_total_funding_amount: '供资总额',
  dbi_company_transaction_name: '交易名称',
  dbi_company_number_acquisitions: '收购次数',
  dbi_company_acquiree_name: '收购方名称',
  dbi_company_price: '价格',
  dbi_company_number_exits: '撤资数量',
  dbi_company_current_team: '当前团队',
  dbi_company_andrew_wilson: '团队成员，包括创始人、首席执行官兼执行董事{message}',
  dbi_company_number_members: '现有团队成员人数',
  dbi_company_members_advisors: '董事会成员和顾问',
  dbi_company_holdings_members: '董事会成员和顾问,包括{message}',
  dbi_company_members_person: ' 董事会成员/顾问人数',
  dbi_company_entity_select_label: '全部实体相关',
};
